import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { addToCart, getTopDishes, dashboardAddToCart } from '../../functions/orders';
import { useSelector } from 'react-redux';
import { motion } from "framer-motion";
import { IconButton, Button, Tab, Tabs, CircularProgress, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import toast from 'react-hot-toast';
import Lottie from 'react-lottie';
import * as animationData from '../../data/food.json'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData
};

const Details = () => {
    const { branch: { currentBranch: { restaurant_code, id: branchId } }, auth: { user: { id: user_id } } } = useSelector((state) => state);
    const { id } = useParams();

    const [item, setItem] = useState({});
    const [addOns, setAddOns] = useState([]);
    const [sides, setSides] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false)


    const [selectedVariants, setSelectedVariants] = useState({});
    const [displayPrice, setDisplayPrice] = useState(0);




    const { food_addons, food_image_json, food_name, price, variants, description, food_code } = item;
    const { state } = useLocation() || null;

    const handleAddsOn = (addOn) => {
        if (addOns.indexOf(addOn) === -1) {
            setAddOns([...addOns, addOn])
        } else {
            const a = [...addOns].filter(x => x.price !== addOn.price);
            setAddOns(a)
        }
    };

    const handleSides = (side) => {
        setSides([side]);
    };

    useEffect(() => {
        getTopDishes(branchId).then(res => {
            const { data: { data } } = res;
            setItem(data?.find(item => item.id === id))
        })
    }, []);

    useEffect(() => {
        if (variants?.length > 0) {
            const defaults = {};
            variants.forEach(v => {
                defaults[v.name] = v.values[0];
            });
            setSelectedVariants(defaults);
            setDisplayPrice(Number(variants[0].values[0].price));
        } else {
            setDisplayPrice(price);
        }
    }, [variants, price]);

    const handleVariantChange = (variantName, value) => {
        setSelectedVariants(prev => ({
            ...prev,
            [variantName]: value
        }));

        // Portion-based pricing (common case)
        setDisplayPrice(Number(value.price));
    };
    console.log('selected variants', selectedVariants);
    const basePrice =
        variants?.length > 0
            ? Number(Object.values(selectedVariants)[0]?.price)
            : price;
    const addonsTotal = addOns.reduce(
        (acc, addOn) => acc + Number(addOn.price || 0),
        0
    );
    const totalAmount = (basePrice * quantity) + addonsTotal;
    const handleAddToCart = () => {
        if (food_addons?.filter(el => el?.addon?.dish_category === 'side')?.length > 0 && sides.length === 0) {
            toast.error("You need to choose side")
        } else {
            setLoading(true)
            function getAddOns() {
                let arr = [];

                for (let el of addOns) {
                    arr.push({ food_id: el.food_code })
                }

                return arr;
            }


            const payload = {
                restaurant_code,
                quantity,
                food_code,
                additional_notes: "",

                add_ons: getAddOns(),

                amount:
                    (basePrice * quantity) +
                    addOns.reduce((acc, addOn) => acc + addOn.price, 0),

                variant:
                    variants?.length > 0
                        ? Object.entries(selectedVariants).map(([name, value]) => ({
                            name,                       // e.g. "Portions"
                            value: value.value_name,    // e.g. "Full serve"
                            price: Number(value.price)  // e.g. 740
                        }))
                        : [],

                ...(state ? { order_id: state?.id } : {})
            };
            console.log('cat payload', payload)
            function s(response) {
                toast.success(response.data.message);
                window.history.back();
                setLoading(false)
            }

            function e(error) {
                toast.success(error.data?.message);
                setLoading(false)
            }

            state ? addToCart(payload).then(response => { s(response) }).catch(error => e(error)) :
                dashboardAddToCart(payload, user_id).then(res => s(res)).catch(error => e(error));
        }
    };

    const renderNoData = (text) => {
        return (
            <Box sx={{ width: 300 }}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                >
                    <Lottie options={defaultOptions}
                        height={100}
                        width={100}
                    />
                    <Typography sx={{ textAlign: "center", fontSize: 12, fontStyle: 'italic' }}>{text}</Typography>
                </motion.div>
            </Box>
        )
    }

    return (
        <Grid container sx={{ overflow: "hidden", pb: 4, pt: 2 }}>
            <Grid item md={5} lg={4} xs={12} sx={{ position: "relative" }}>
                <div className='z-99 absolute top-0 p-4 left-0 h-56 w-full lg:h-96'>
                    <div className='flex flex-row justify-between items-center'>
                        {[ArrowBackIcon].map((El) => (
                            <div className='bg-white shadow h-8 w-8 cursor-pointer rounded-full flex flex-row items-center justify-center'>
                                <El onClick={() => window.history.back()} />
                            </div>
                        ))}
                    </div>
                </div>

                <img
                    src={Array.isArray(food_image_json) ? food_image_json[0]?.url : ""}
                    alt="burger"
                    className='rounded-lg h-56 w-[100%] object-cover bg-white shadow lg:h-96'
                />

                <div className='grid grid-cols-3 gap-3 mt-4 w-[100%]'>
                    {Array(3).fill(Array.isArray(food_image_json) ? food_image_json[0]?.url : "").map((item) => (
                        <img src={item} alt="item" className='w-[100%] h-24 rounded-lg object-cover bg-white shadow' />
                    ))}
                </div>

                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={0} aria-label="tab">
                            <Tab label="Description" />
                        </Tabs>
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: 14, mt: 1 }}>{description}</Typography>
                    </Box>
                </Box>
            </Grid>

            <Grid
                item
                lg={8}
                md={7}
                xs={12}
                sx={{ display: "flex", flexDirection: "column", rowGap: 3 }}
                className='lg:!px-14'
            >
                <div>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography component="legend" sx={{ fontSize: 18 }}>4</Typography>
                        <Rating size='small' name="simple-controlled" value={4} />
                    </Box>
                    <h2 className='font-bold text-xl capitalize'>{food_name?.charAt(0)?.toUpperCase() + food_name?.slice(1)?.toLowerCase()}</h2>
                    <p className='text-sm'>Preparation time 30 mins</p>
                </div>
            

                {variants?.length > 0 && (
                    <div className="space-y-6">

                        {variants.map((variant) => (
                            <div
                                key={variant.name}
                                className="rounded-2xl  bg-white py-4"
                            >
                                {/* Variant title */}
                                <h2 className="font-semibold text-lg mb-3">
                                    {variant.name}
                                </h2>

                                {/* Scrollable values */}
                                <div className="max-h-[280px] overflow-y-auto pr-1">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">

                                        {variant.values.map((value) => {
                                            const isSelected =
                                                selectedVariants[variant.name]?.value_name === value.value_name;

                                            return (
                                                <div
                                                    key={value.value_name}
                                                    onClick={() =>
                                                        handleVariantChange(variant.name, value)
                                                    }
                                                    className={`
                    relative flex items-center justify-between gap-3
                    p-3 rounded-xl cursor-pointer border transition-all
                    active:scale-[0.98]
                    ${isSelected
                                                            ? "border-primary border bg-maroon-500/5 shadow-sm"
                                                            : "border-gray-200 hover:border-primary/40"
                                                        }
                  `}
                                                >
                                                    {/* Border-corner check */}
                                                    {isSelected && (
                                                        <div
                                                            className="
                        absolute -top-1 -right-2
                        w-5 h-5
                        bg-white
                        rounded-full
                        border-2 border-primary
                        flex items-center justify-center 
                      "
                                                        >
                                                            <CheckCircleIcon
                                                                sx={{ fontSize: 14 }}
                                                                className="text-primary"
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Value name */}
                                                    <p className="text-sm font-medium truncate">
                                                        {value.value_name}
                                                    </p>

                                                    {/* Price */}
                                                    <p className="text-sm font-bold text-primary whitespace-nowrap">
                                                        KES {Number(value.price).toLocaleString()}
                                                    </p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                )}


                <div>
                    <h2 className='font-bold'>Choice of Extras</h2>
                    <p className='text-sm'>Choose upto to three items</p>

                    {
                        food_addons?.filter(el => el?.addon?.dish_category === 'extra')?.length > 0 ?
                            <div className='grid grid-cols-1 mt-2 md:grid-cols-2'>
                                {food_addons?.filter(el => el?.addon?.dish_category === 'extra')?.map(({ addon }) => (
                                    <div className='flex flex-row space-x-10 items-center'>
                                        <div className='flex flex-row items-center'>
                                            <Checkbox checked={addOns.indexOf(addon) !== -1} onChange={() => handleAddsOn(addon)} sx={{ ml: -1 }} size='small' />
                                            <p className='text-[15px] capitalize'>{addon?.food_name}</p>
                                        </div>

                                        <h2 className='text-sm font-bold text-primary'> {addon?.price?.toLocaleString("en", {
                                            style: "currency",
                                            currency: "KSH",
                                        })}</h2>
                                    </div>
                                ))}
                            </div>
                            :
                            renderNoData("This food item does not have extras")
                    }
                </div>

                <div>
                    <h2 className='font-bold'>Choice of Sides</h2>
                    <p className='text-sm'>Choose one items</p>

                    {
                        food_addons?.filter(el => el?.addon?.dish_category === 'side')?.length > 0 ?
                            <div className='grid grid-cols-1 gap-x-8 mt-2'>
                                {food_addons?.filter(el => el?.addon?.dish_category === 'side')?.map(({ addon }) => (
                                    <div className='flex flex-row space-x-24 items-center' key={addon.food_name}>
                                        <div className='flex flex-row items-center'>
                                            <Checkbox checked={sides.includes(addon)} sx={{ ml: -1 }} size='small' onChange={() => handleSides(addon)} />
                                            <p className='text-[15px] capitalize'>{addon?.food_name}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            renderNoData("This food item does not have sides")
                    }
                </div>

                <div className='flex flex-row items-center space-x-4'>
                    <div className='flex flex-row items-center bg-gray-100 rounded px-2 space-x-4'>
                        <IconButton
                            disabled={quantity === 1}
                            onClick={() => setQuantity(quantity - 1)}
                        >
                            <RemoveIcon />
                        </IconButton>

                        <p className='font-bold'>{quantity.toString().padStart(2, "0")}</p>

                        <IconButton onClick={() => setQuantity(quantity + 1)}>
                            <AddIcon />
                        </IconButton>
                    </div>
                    {/* 
                    <Button
                        variant='contained'
                        sx={{ width: "100%", color: "white" }}
                        onClick={handleAddToCart}
                    >
                        {loading ? <CircularProgress size={24} color='inherit' /> : "Add to Cart"}
                    </Button> */}
                    <Button
                        variant="contained"
                        sx={{ width: "100%", color: "white" }}
                        onClick={handleAddToCart}
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            `Add to Cart • KES ${totalAmount.toLocaleString()}`
                        )}
                    </Button>
                </div>

            </Grid>
        </Grid>
    )
}

export default Details